import React, { useEffect, useState } from 'react';
import 'react-phone-input-2/lib/style.css';
import { DocumentProps } from "../../types/types";
import { AdditionalDocuments } from './additional-documents';
import { AllDocuments } from "./all-documents";
import { RequiredDocuments } from './required-documents';


export const UploadDocuments: React.FC<{
  listOfDocuments: DocumentProps[],
  onChange?: ( page: string ) => void;
  isBack?: boolean;
}> = ( props ) => {

  const { listOfDocuments, onChange, isBack } = props;

  const [listOfRequiredDocuments, setListOfRequiredDocuments] = useState<DocumentProps[] | undefined>();
  const [listOfAdditionalDocuments, setListOfAdditionalDocuments] = useState<DocumentProps[] | undefined>();
  const [uploadedRequired, setUploadedRequired] = useState<DocumentProps[]>([]);
  const [uploadedAdditional, setUploadedAdditional] = useState<DocumentProps[]>([]);

  const [progressRequired, setProgressRequired] = useState<number>(0);
  const [progressAdditional, setProgressAdditional] = useState<number>(0);

  const [showRequiredDocuments, setShowRequiredDocuments] = useState<boolean>(false);
  const [showAdditionalDocuments, setShowAdditionalDocuments] = useState<boolean>(false);


  function getPage() {
    if (showRequiredDocuments) {
      return 'showRequiredDocuments';
    }
    if (showAdditionalDocuments) {
      return 'showAdditionalDocuments';
    }
    return 'allDocuments';
  }

  useEffect(() => {
   if (isBack) {
     setShowRequiredDocuments(false);
     setShowAdditionalDocuments(false);
   }
  }, [isBack]);

  useEffect(() => {
    const page = getPage();
    onChange?.(page);
  }, [showRequiredDocuments, showAdditionalDocuments]);

  useEffect(() => {
    setListOfRequiredDocuments(listOfDocuments?.filter(( document: DocumentProps ) => document.required));
    setListOfAdditionalDocuments(listOfDocuments?.filter(( document: DocumentProps ) => !document.required));
  }, [listOfDocuments]);

  useEffect(() => {
    if (listOfRequiredDocuments && listOfAdditionalDocuments) {
      setUploadedRequired(listOfRequiredDocuments?.filter(( document: DocumentProps ) => document.uploaded));
      setUploadedAdditional(listOfAdditionalDocuments?.filter(( document: DocumentProps ) => document.uploaded));
    }
  }, [listOfRequiredDocuments, listOfAdditionalDocuments]);

  useEffect(() => {
    if (listOfRequiredDocuments && listOfAdditionalDocuments) {
      setProgressRequired(uploadedRequired?.length ? (uploadedRequired?.length / listOfRequiredDocuments?.length) * 100 : 0);
      setProgressAdditional(uploadedAdditional?.length ? (uploadedAdditional?.length / listOfAdditionalDocuments?.length) * 100 : 0);
    }
  }, [uploadedAdditional, uploadedRequired]);

  return (
    <>
      {
        showRequiredDocuments && (

          <RequiredDocuments listOfDocuments={listOfRequiredDocuments || []}/>
        )
      }
      {
        showAdditionalDocuments && (
          <AdditionalDocuments listOfDocuments={listOfAdditionalDocuments || []}/>
        )
      }

      {!showRequiredDocuments && !showAdditionalDocuments && (
        <AllDocuments progressRequired={progressRequired}
                      progressAdditional={progressAdditional} uploadedAdditional={uploadedAdditional}
                      uploadedRequired={uploadedRequired} listOfAdditionalDocuments={listOfAdditionalDocuments || []}
                      listOfRequiredDocuments={listOfRequiredDocuments || []}
                      setShowAdditionalDocuments={( show: boolean ) => {
                        setShowAdditionalDocuments(show);
                      }}
                      setShowRequiredDocuments={( show: boolean ) => {
                        setShowRequiredDocuments(show);
                      }}/>
      )}

    </>
  );
}

